import Breadcrumb from "~/components/ui/Breadcrumb";

import { type SectionProps as SectionProps } from "~/types/deco";
interface Item {
    /**
     * @title Nome
     */
    label: string;
    /**
     * @title URL
     * @description Se não for definido, será utilizado o nome do item em letras maiúsculas, por exemplo: Aarem será redirecionado para /AAREM
     */
    url?: string;
}
interface Group {
    /**
     * @title Nome
     */
    label: string;
    /**
     * @title URL
     */
    items: Item[];
}
export interface Props {
    /**
     * @title Texto
     * @format html
     */
    text?: string;
    /**
     * @title Itens
     * @description Lista de itens do glossário
     */
    groups: Group[];
}
export default function Glossary({ text = '', groups }: SectionProps<typeof loader>) {
    const breadcrumb = [
        {
            '@type': 'ListItem' as const,
            item: '/glossario',
            name: 'Glossário',
            position: 0,
        },
    ];
    return (<div className='w-full max-w-[1810px] mx-auto mb-8'>
            <div className='px-3 my-4 flex items-center gap-2'>
                <Breadcrumb itemListElement={breadcrumb}/>
            </div>

            <div className='max-w-[864px] px-3 mx-auto'>
                {!!text && (<div className='[&_h1]:mb-4 [&_h1]:text-salmon [&_h1]:text-2xl [&_h1]:font-extrabold [&_p]:text-[#7a7a7a] [&_p]:text-[15px] [&_p]:leading-5' dangerouslySetInnerHTML={{ __html: text }}/>)}

                <ul className='mt-8 mb-5 rounded overflow-x-auto bg-[#f9f9f9] flex items-center lg:flex-wrap'>
                    {groups.map(({ label }) => (<li>
                            <a className='w-10 h-12 rounded-lg text-red-wine text-lg font-bold flex justify-center items-center hover:bg-red-wine hover:text-white' href={`#${label.at(0)}`}>
                                {label.at(0)}
                            </a>
                        </li>))}
                </ul>

                <ul className='divide-y divide-red-wine/25'>
                    {groups.map(({ label, items }) => (<li id={label} className='py-3'>
                            <h2 className='mb-5 text-red-wine text-2xl font-bold'>{label}</h2>

                            <ul className='grid grid-cols-2 gap-y-3'>
                                {items.map(({ label, url }) => (<li>
                                        <a className='text-[#2b2b2b] text-[15px] leading-7 capitalize' href={url}>
                                            {label}
                                        </a>
                                    </li>))}
                            </ul>
                        </li>))}
                </ul>
            </div>
        </div>);
}
export const loader = (props: Props, request: Request) => {
    if (!props.groups?.length) {
        // Section was misconfigured (no groups). Render empty state instead
        // of crashing the page. Original Fresh code threw `redirect()` here.
        return { ...props, groups: [] };
    }
    return {
        ...props,
        groups: props.groups
            .filter(({ items }) => items.length)
            .map(({ items, ...group }) => ({
            ...group,
            items: items.map((item) => ({
                ...item,
                url: item.url ?? new URL(item.label.toUpperCase(), request.url).pathname,
            })),
        })),
    };
};
